module.exports = __webpack_public_path__ + "img/8.d3838949.jpg";